<template>
  <v-app id="inspire" style="overflow:auto">
    <Header v-if="$route.name !== 'Login'" />
    <v-main>
      <Main />
    </v-main>
    <v-snackbars :messages.sync="messages" top right timeout='0' color='warning'>
      <template v-slot:action="{ close }">
        <v-btn text @click="close()">Dispensar</v-btn>
      </template>
    </v-snackbars>
  </v-app>
</template>

<script>
import Header from "./components/Header.vue";
import Main from "./components/Main.vue";
import VSnackbars from "v-snackbars"
export default {
  components: {
    Header,
    Main,
    "v-snackbars": VSnackbars,
  },
  props: {
    source: String,
  },
  data: () => ({
    drawer: null,
    messages: [],
  }),
  mounted() {
    if (this.$store.getters.getUserData.table_key === 'prefectures') {
      this.$http
        .get(`/parts-and-services/item/alert/${this.$store.getters.getUserData.table_id}`)
        .then((r) => {
          r.data.validity.forEach(item => {
            this.messages.push(`O item ${item.name} vence dia ${this.convertDate(item.validity)}`)
          });
          r.data.qtdMin.forEach(item => {
            this.messages.push(`O item ${item.name} atingiu a quantidade mínima`)
          });
        })
    }
  },
  methods: {
    convertDate(date) {
      if (date) {
        date = date.replace("-", "").replace("-", "");
        const year = date.substring(0, 4);
        const month = date.substring(4, 6);
        const day = date.substring(6, 8);
        return `${day}/${month}/${year}`;
      } else {
        return false;
      }
    },
  }
};
</script>